import React, { useEffect, useState } from 'react'
import MapGL, { Marker, NavigationControl } from 'react-map-gl'
import { makeStyles } from '@material-ui/core/styles'
import SatelliteIcon from '@material-ui/icons/SatelliteRounded'
import MapIcon from '@material-ui/icons/MapRounded'
import clsx from 'clsx'

import { MAPBOX } from '../../config/Keys'
import { NORMAL_STYLE, SATELLITE_STYLE } from '../../config/Map'

const useStyles = makeStyles((theme) => ({
    root: {
        height: ({ height }) => height,
        width: '100%',
        overflow: 'hidden',
    },
    icon: {
        width: 20,
        height: 20,
        borderRadius: 100,
        borderColor: '#fff',
        borderWidth: 3,
        borderStyle: 'solid',
        backgroundColor: theme.palette.primary.main,
    },
}))

const DynamicMap = ({
    latitude,
    longitude,
    zoom = 15,
    default_satellite = true,
    marker,
    height,
    width,
    margin,
    children,
    ...props
}) => {
    const classes = useStyles({ height, width })

    const [mapStyle, setMapStyle] = useState(
        default_satellite ? SATELLITE_STYLE : NORMAL_STYLE
    )
    const toggleMapStyle = () => {
        if (mapStyle === SATELLITE_STYLE) {
            setMapStyle(NORMAL_STYLE)
        } else {
            setMapStyle(SATELLITE_STYLE)
        }
    }
    const isSatellite = mapStyle === SATELLITE_STYLE

    const [map, setMap] = useState({
        latitude,
        longitude,
        zoom,
    })

    useEffect(() => {
        setMap({
            latitude,
            longitude,
            zoom,
        })
    }, [latitude, longitude, zoom])

    return (
        <div className={classes.root}>
            <MapGL
                width="100%"
                height="100%"
                scrollZoom={false}
                mapboxApiAccessToken={MAPBOX}
                onViewportChange={setMap}
                mapStyle={mapStyle}
                {...map}
                {...props}
            >
                {children}
                {marker && (
                    <Marker
                        latitude={marker.latitude}
                        longitude={marker.longitude}
                    >
                        <div className={clsx(classes.icon, 'with-ripple')} />
                    </Marker>
                )}
                <div className="mapboxgl-ctrl-top-left">
                    <NavigationControl />
                    <div
                        className="mapboxgl-ctrl-group mapboxgl-ctrl"
                        style={{ marginTop: 110 }}
                    >
                        <button
                            title="Toggle map style (Satellite/Normal)"
                            onClick={toggleMapStyle}
                        >
                            {isSatellite ? <MapIcon /> : <SatelliteIcon />}
                        </button>
                    </div>
                </div>
            </MapGL>
        </div>
    )
}

export default DynamicMap
